var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEventsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 8.9L20.4 5L19.1 6.5L23.7 10.4L25 8.9ZM10.9 6.6L9.6 5.1L5 8.9L6.3 10.4L10.9 6.6ZM15.5 11.2H14V17.2L18.7 20.1L19.5 18.9L15.5 16.5V11.2ZM15 7.2C10 7.2 6 11.2 6 16.2C6 21.2 10 25.2 15 25.2C20 25.2 24 21.2 24 16.2C24 11.2 20 7.2 15 7.2ZM15 23.2C11.1 23.2 8 20.1 8 16.2C8 12.3 11.1 9.2 15 9.2C18.9 9.2 22 12.3 22 16.2C22 20.1 18.9 23.2 15 23.2Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIcon);
export default __webpack_public_path__ + "static/media/EventsIcon.c6fabb2f.svg";
export { ForwardRef as ReactComponent };